module.exports = __webpack_public_path__ + "static/img/minGW_manager.961f549.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assignments/c/images/minGW_manager.png
// module id = x2tm
// module chunks = 1